import { useEffect } from 'react';
import type { ReactElement } from 'react';
import { Nullable } from 'types';

const ScrollSaver = ({
  children,
  scrollableParent,
  savedScrollPosition,
  saveScrollPosition,
}: {
  children: ReactElement;
  scrollableParent: Nullable<HTMLElement>;
  savedScrollPosition: number;
  saveScrollPosition: (pos: number) => void;
}): ReactElement => {
  useEffect(() => {
    if (scrollableParent) {
      scrollableParent.scrollTo(0, savedScrollPosition);
    }
    return () => {
      if (scrollableParent) {
        saveScrollPosition(scrollableParent.scrollTop);
      }
    };
    // eslint-disable-next-line
  }, [scrollableParent]);

  return children;
};

export default ScrollSaver;
